module.exports = __webpack_public_path__ + "img/avatar.eaa756d4.jpg";